module.exports = __webpack_public_path__ + "assets/table.eaa149fe.png";